export const EVENT_PLATFORM_APPLICATIONS = 1;
export const EVENT_PLATFORM_EVENTS = 2;

const normalizeAccessLevel = (value) => {
  const level = Number(value);
  return Number.isFinite(level) ? level : 0;
};

export const getEventPlatformAccess = (userState, platform) => {
  if (Number(platform) === EVENT_PLATFORM_APPLICATIONS) {
    return normalizeAccessLevel(userState?.plataforma_aplicativos);
  }

  if (Number(platform) === EVENT_PLATFORM_EVENTS) {
    return normalizeAccessLevel(userState?.plataforma_eventos);
  }

  return 0;
};

export const canManageEvent = (userState, platform) =>
  getEventPlatformAccess(userState, platform) === 2;

export const canEditEventReports = (userState, platform) =>
  getEventPlatformAccess(userState, platform) >= 1;

export const canManageStreaming = (userState, platform) =>
  canManageEvent(userState, platform);

export const canAccessAdminEventSections = (userState, platform) =>
  canManageEvent(userState, platform);

export const canAccessEventEmails = (userState, platform) =>
  Number(platform) === EVENT_PLATFORM_EVENTS &&
  canAccessAdminEventSections(userState, platform);

export const canAccessEventWhatsApp = (userState, platform) =>
  Number(platform) === EVENT_PLATFORM_EVENTS &&
  canAccessAdminEventSections(userState, platform);

export const canAccessEventRsvps = (userState, platform) =>
  Number(platform) === EVENT_PLATFORM_EVENTS &&
  canAccessAdminEventSections(userState, platform);
